<template lang="pug">
  .video-field
    template(v-if="isVideoSelected")
      video-thumbnail-detail(
        :src="thumbnailUrl"
        :videoUrl="videoUrl"
        :ready="!isUploading"
        @click="$emit('playback', videoUrl)")

      icon(name="delete" @click="deleteVideo" v-if="value.videoKey")

    template(v-else)
      .frame(@click="openMediaLibrary")
        .box
          icon.library(name="library")
          label 動画を選択

    input(
      ref="file"
      type="file"
      accept="video/*"
      @change="onSelectVideoFromFileSystem"
      v-if="!canOpenCameraRoll"
      :multiple="false"
    )
</template>

<style lang="scss" scoped>
.video-field {
  position: relative;
  width: 100%;
  box-sizing: border-box;

  .video-thumbnail-detail {
    margin: 0 16px;
  }

  .frame {
    margin: 0 16px;
    padding-top: 100%;
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 4px;
    overflow: hidden;

    .box {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;

      .library {
        width: 24px;
        height: 19px;
        opacity: 0.6;
      }

      label {
        margin-top: 16px;
        @extend %label-text;
        opacity: 0.6;
        font-size: 14px;
        line-height: 21px;
      }
    }
  }

  .icon.delete {
    position: absolute;
    width: 34px;
    height: 34px;
    top: 7px;
    right: 23px;
    z-index: 10;
  }

  input {
    display: none;
  }
}
</style>

<script>
import path from 'path'
import VideoService from '@/services/VideoService'
import MediaOpener from '@/components/mixins/MediaOpener'
import VideoThumbnailDetail from '@/components/atoms/VideoThumbnailDetail'

export default {
  props: {
    value: Object,
    selectedVideo: Object,
  },
  mixins: [MediaOpener],
  components: {
    VideoThumbnailDetail,
  },
  data() {
    return {
      isUploading: false,
      selectedFile: null,
    }
  },
  asyncComputed: {
    thumbnailUrl: {
      async get() {
        if (this.selectedFile) {
          return await new VideoService().generateThumbnail(this.selectedFile)
        } else if (this.value.thumbnailKey) {
          return this.selectedVideo && this.selectedVideo.thumbnailUrl
        }
      },
      default: '',
    },
  },
  computed: {
    videoUrl() {
      if (this.selectedFile) {
        return URL.createObjectURL(this.selectedFile)
      } else if (this.value.thumbnailKey && this.selectedVideo) {
        return this.selectedVideo.videoUrl
      }
      return ''
    },
    isVideoSelected() {
      // just uploaded
      if (this.selectedFile) {
        return true
      }
      // edit draft and not removed
      if (this.value.thumbnailKey && this.selectedVideo) {
        return true
      }
      // removed or not uploaded
      return false
    },
  },
  methods: {
    updateValue(diff) {
      this.$emit('input', { ...this.value, ...diff })
    },
    async openMediaLibrary() {
      if (this.canOpenCameraRoll) {
        const url = await this.openCameraRoll().catch((msg) =>
          /* eslint-disable no-console */
          console.log(`failed because: ${msg}`)
        )
        this.onSelectVideoFromCameraRoll(url)
      } else {
        this.$refs.file.click()
      }
    },
    onSelectVideoFromCameraRoll(url) {
      const type = path.basename(url).replace('.', '').toLowerCase()

      setTimeout(() => {
        this.selectedFile = url
        this.uploadVideo(url, type)
      }, 2000)
    },
    onSelectVideoFromFileSystem(event) {
      const file = event.target.files[0]
      const basename = path.basename(file.name)
      const type = path.extname(basename).replace('.', '').toLowerCase()

      if (type == 'mp4' || type == 'mov') {
        this.selectedFile = file
        this.uploadVideo(file, type)
      } else {
        this.$f7.dialog.alert('未対応の動画です')
      }
    },
    async uploadVideo(videoFile, type) {
      this.isUploading = true
      this.$emit('upload', true)

      const result = await new VideoService().upload(videoFile, {
        dirname: 'curriculums',
        type: type,
      })

      this.isUploading = false
      this.$emit('upload', false)
      this.$emit('input', result)
    },
    deleteVideo() {
      this.$f7.dialog.confirm(
        'このビデオを削除してよろしいですか？',
        '確認',
        () => {
          if (this.$refs.file) this.$refs.file.value = ''
          this.selectedFile = null
          this.$emit('input', { videoKey: null, thumbnailKey: null })
        }
      )
    },
  },
}
</script>
